/**
 * 人群统计(1.4基于区域计数)
 */
import colors from '@/styles/color.scss';
import { langTextInit, getLangTxt } from '@blade/common/utils/echartUtils';
import lang from '@blade-sxp/task-management/lang/task-type';
langTextInit(lang);
// model type 模型类型
const modelTypeData = [
    {
        value: 'LOCALIZATION',
        label: getLangTxt('headNod'),
    },
    // {
    //   value: 'HARPY', // 人体框模型
    //   label: '人体框'
    // },
    {
        value: 'HEAD_SHOULDER',
        label: getLangTxt('headShoulders'),
    },
];
// CROWD_STATISTIC('人群统计')
const CROWD_STATISTIC = {
    drawingProcess: {
        roi: true,
        map: true,
        direction: false,
        bodyFrame: true,
    },
    timeline: [
        { index: 1, text: 'Model Type', type: 'MODEL', isComplete: true, data: modelTypeData[0].value, enableAttributesAnalysis: false },
        { index: 2, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] },
        { index: 3, text: 'Mark on Map', type: 'MAP', isComplete: false, data: [] },
        { index: 4, text: 'Body Frame', type: 'BODY', isComplete: false, data: [] },
    ],
    incidentType: 'INCIDENT_FIRE_DETECTION',
    multipleRoi: {
        status: false,
        quantity: 2,
    },
    bodyAttributeRecognition: true,
    notNecessarily: false,
};
/**
 * 排队任务(1.4基于区域统计及跨线统计)
 */
// QUEUE('排队任务'),
/**
 * 虚拟区域统计
 */
// VIRTUAL_CROWD_STATISTIC('虚拟区域统计'),
/**
 * 离岗检测
 */
// OFF_DUTY_DETECTION('离岗检测'),
/**
 * 密度告警
 */
// CROWD_DENSITY('人群密度告警'),
const CROWD_DENSITY = {
    drawingProcess: {
        roi: true,
        map: true,
        direction: false,
        bodyFrame: true,
    },
    timeline: [
        { index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] },
        { index: 2, text: 'Mark on Map', type: 'MAP', isComplete: false, data: [] },
        { index: 3, text: 'Body Frame', type: 'BODY', isComplete: false, data: [] },
    ],
    incidentType: 'INCIDENT_DENSITY',
    multipleRoi: {
        status: false,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 人群逆流
 */
// CROWD_RETROGRADE('人群逆流告警'),
const CROWD_RETROGRADE = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: true,
        bodyFrame: true,
    },
    timeline: [
        { index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] },
        { index: 2, text: 'Direction', type: 'DIRECTION', isComplete: false, data: [] },
        { index: 3, text: 'Body Frame', type: 'BODY', isComplete: false, data: [] },
    ],
    incidentType: 'INCIDENT_RETROGRADE',
    multipleRoi: {
        status: false,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 社交距离告警
 */
// CROWD_SOCIAL_DISTANCE('人群社交距离告警'),
const CROWD_SOCIAL_DISTANCE = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: true,
    },
    timeline: [
        { index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] },
        { index: 2, text: 'Body Frame', type: 'BODY', isComplete: false, data: [] },
    ],
    incidentType: 'INCIDENT_SOCIAL_DISTANCE',
    multipleRoi: {
        status: false,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 聚集分散告警
 */
// CROWD_CONGREGATE('人群聚集分散告警'),
const CROWD_CONGREGATE = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: true,
    },
    timeline: [
        { index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] },
        { index: 2, text: 'Body Frame', type: 'BODY', isComplete: false, data: [] },
    ],
    incidentType: 'INCIDENT_CONGREGATE',
    multipleRoi: {
        status: false,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 入侵告警
 */
// CROWD_INTRUSION('人群入侵告警'),
const CROWD_INTRUSION = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: true,
    },
    timeline: [
        { index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] },
        { index: 2, text: 'Body Frame', type: 'BODY', isComplete: false, data: [] },
    ],
    incidentType: 'INCIDENT_INTRUSION',
    multipleRoi: {
        status: false,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 人群滞留告警
 */
// CROWD_STRAND('人群滞留告警'),
const CROWD_STRAND = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: true,
    },
    timeline: [
        { index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] },
        { index: 2, text: 'Body Frame', type: 'BODY', isComplete: false, data: [] },
    ],
    incidentType: 'INCIDENT_STRAND',
    multipleRoi: {
        status: false,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 单跨线统计
 */
// CROWD_CROSS_LINE_STATISTIC('人群跨线统计'),
/**
 * 人脸比中布控任务
 */
// 人脸 人体 车辆 只看视频》》》》》》》》》》》》》》
// FACE_ALERT('人脸布控'),
const FACE_ALERT = {
    drawingProcess: {
        roi: false,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [],
    incidentType: 'INCIDENT_FACE',
    multipleRoi: {
        status: false,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 人脸人体比中布控
 */
// FACE_PEDESTRIAN_ALERT('人脸人体布控'),
const FACE_PEDESTRIAN_ALERT = {
    drawingProcess: {
        roi: false,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [],
    incidentType: 'INCIDENT_FACE_PEDESTRIAN',
    multipleRoi: {
        status: false,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 人脸属性提取任务
 */
// FACE_ATTRIBUTE('人脸属性'),
const FACE_ATTRIBUTE = {
    drawingProcess: {
        roi: false,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [],
    incidentType: 'INCIDENT_FACE',
    multipleRoi: {
        status: false,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 人体属性提取任务
 */
// PEDESTRIAN_ATTRIBUTE('人体属性'),
const PEDESTRIAN_ATTRIBUTE = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_PEDESTRIAN',
    multipleRoi: {
        status: true,
        quantity: 2,
    },
    notNecessarily: true,
};
/**
 * 车辆属性````
 */
// AUTOMOBILE_ATTRIBUTE('车辆属性');
const AUTOMOBILE_ATTRIBUTE = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_AUTOMOBILE',
    multipleRoi: {
        status: true,
        quantity: 2,
    },
    notNecessarily: true,
};
/**
 * 道路检测
 */
//  ROAD_DEFECTION_DETECT 道路检测属性
const ROAD_DEFECTION_DETECT = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_ROAD_DETECTION',
    multipleRoi: {
        status: true,
        quantity: 2,
    },
    notNecessarily: true,
};
/**
 * 垃圾检测
 */
//  TRASH_DETECT 垃圾检测属性
const TRASH_DETECT = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_TRASH_DETECTION',
    multipleRoi: {
        status: true,
        quantity: 2,
    },
    notNecessarily: true,
};
/**
 * 厨房任务
 */
//  KITCHEN_STAFF_DETECT 厨房检测事件
const KITCHEN_STAFF_DETECT = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_KITCHEN_DETECTION',
    multipleRoi: {
        status: true,
        quantity: 8,
        behavior: [
            {
                id: '1',
                type: 'Personnel Behavior',
                label: getLangTxt('personnelBehavior'),
                value: 'kitchenBehaviorDetectConfig',
                color: colors.polygonStrokeStyle,
                roiColor: {
                    fillColors: colors.polygonStrokeStyle,
                    strokeColor: colors.polygonStrokeStyle,
                },
            },
            {
                id: '2',
                type: 'Animals & Pest',
                label: getLangTxt('animalsInsects'),
                value: 'pestDetectConfig',
                color: colors.colorDanger,
                roiColor: {
                    fillColors: colors.colorDanger,
                    strokeColor: colors.colorDanger,
                },
            },
            {
                id: '3',
                type: 'Table Detection',
                label: getLangTxt('tableDetection'),
                value: 'tableDetectConfig',
                color: colors.lineFillStyle,
                roiColor: {
                    fillColors: colors.lineFillStyle,
                    strokeColor: colors.lineFillStyle,
                },
            },
            {
                id: '4',
                type: 'Kitchenware',
                label: getLangTxt('kitchenware'),
                value: 'kitchenWareDetectConfig',
                color: colors.boardLevelMajorColor,
                roiColor: {
                    fillColors: colors.boardLevelMajorColor,
                    strokeColor: colors.boardLevelMajorColor,
                },
            },
        ], // 特殊处理
    },
    notNecessarily: true,
};
/**
 * 人群跨线
 */
// CROWD_INTRUSION('人群跨线告警'),
const CROWD_CROSS_LINE_STATISTIC = {
    drawingProcess: {
        roi: false,
        map: false,
        direction: false,
        lines: true,
        bodyFrame: true,
    },
    timeline: [
        { index: 1, text: 'Model Type', type: 'MODEL', isComplete: true, data: modelTypeData[0].value },
        { index: 2, text: 'Crossline', type: 'LINES', isComplete: false, data: [] },
        { index: 3, text: 'Body Frame', type: 'BODY', isComplete: false, data: [] },
    ],
    incidentType: 'INCIDENT_CROSS_LINE',
    multipleRoi: {
        status: false,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 跨线
 */
// CROWD_INTRUSION('跨线告警'),
const CROSS_LINE_ALERT_DETECT = {
    drawingProcess: {
        roi: false,
        map: false,
        direction: false,
        lines: true,
        bodyFrame: true,
    },
    timeline: [
        { index: 1, text: 'Crossline', type: 'LINES', isComplete: false, data: [] },
        { index: 2, text: 'Body Frame', type: 'BODY', isComplete: false, data: [] },
    ],
    incidentType: 'INCIDENT_CROSS_LINE',
    multipleRoi: {
        status: false,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 异常检测
 */
//  ABNORMAL_BEHAVIOR_DETECT 异常检测
const ABNORMAL_BEHAVIOR_DETECT = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_ABNORMAL_BEHAVIOR',
    multipleRoi: {
        status: true,
        quantity: 2,
    },
    notNecessarily: true,
};
/**
 * 烟火
 */
//  FIRE_DETECTION_DETECT 烟火
const FIRE_DETECTION_DETECT = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_FIRE_DETECTION',
    multipleRoi: {
        status: true,
        quantity: 2,
    },
    notNecessarily: true,
};
/**
 * 逆行
 */
//  TRAFFIC_RETROGRADE_DETECT 逆行
const TRAFFIC_RETROGRADE_DETECT = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: true,
        bodyFrame: false,
    },
    timeline: [
        { index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] },
        { index: 2, text: 'Direction', type: 'DIRECTION', isComplete: false, data: [] },
    ],
    incidentType: 'INCIDENT_TRAFFIC_RETROGRADE_DETECTION',
    multipleRoi: {
        status: true,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 违停
 */
//  TRAFFIC_VIOLATION_DETECT 违停
const TRAFFIC_VIOLATION_DETECT = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_TRAFFIC_ILLEGAL_STOP_DETECTION',
    multipleRoi: {
        status: true,
        quantity: 5,
    },
    notNecessarily: false,
};
/**
 * 交通入侵
 */
//  TRAFFIC_INTRUSION_DETECT 交通入侵
const NONE_MOTOR_VEHICLE_PEDESTRIAN_DETECT = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_NONE_MOTOR_VEHICLE_PEDESTRIAN_DETECTION',
    multipleRoi: {
        status: true,
        quantity: 5,
    },
    notNecessarily: false,
};
/**
 * 交通拥堵
 */
//  TRAFFIC_JAM_DETECT 交通拥堵
const TRAFFIC_CONGESTION_DETECT = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_TRAFFIC_CONGESTION_DETECTION',
    multipleRoi: {
        status: true,
        quantity: 5,
    },
    notNecessarily: false,
};
/**

 * 虚拟统计
 */
//  VIRTUAL_ZONE_STATISTIC 虚拟统计
const VIRTUAL_ZONE_STATISTIC = {
    drawingProcess: {
        roi: false,
        map: false,
        lines: true,
        direction: false,
        bodyFrame: true,
    },
    timeline: [
        { index: 1, text: 'Model Type', type: 'MODEL', isComplete: true, data: modelTypeData[0].value },
        { index: 2, text: 'Crossline', type: 'LINES', isComplete: false, data: [], tips: { selectDirection: 'crossLineTips' } },
        { index: 3, text: 'Body Frame', type: 'BODY', isComplete: false, data: [] },
    ],
    incidentType: 'INCIDENT_CROSS_LINE',
    multipleRoi: {
        status: false,
        quantity: 5,
    },
    notNecessarily: false,
};
/**

 * 人体跨线
 */
//  PEDESTRIAN_CROSS_LINE 人体跨线
const PEDESTRIAN_CROSS_LINE = {
    drawingProcess: {
        roi: false,
        map: false,
        lines: true,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'Crossline', type: 'LINES', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_PEDESTRIAN_CROSS_LINE_DETECTION',
    multipleRoi: {
        status: false,
        quantity: 1,
    },
    notNecessarily: false,
};
/**
 * 不明物体滞留检测
 *
 */
const UNIDENTIFIED_OBJECT_RETENTION_DETECT = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_UNIDENTIFIED_OBJECT_RETENTION_DETECTION',
    multipleRoi: {
        status: true,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 非机动车
 *
 */
const HUMAN_POWERED_VEHICLE_DETECT = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_HUMAN_POWERED_VEHICLE_DETECTION',
    multipleRoi: {
        status: true,
        quantity: 2,
    },
    notNecessarily: false,
};
/**
 * 万物检测
 */
const EVERYTHING_DETECT = {
    drawingProcess: {
        roi: true,
        map: false,
        direction: false,
        bodyFrame: false,
    },
    timeline: [{ index: 1, text: 'ROI Area', type: 'ROI', isComplete: false, data: [] }],
    incidentType: 'INCIDENT_EVERYTHING_DETECTION',
    multipleRoi: {
        status: true,
        quantity: 2,
    },
    notNecessarily: true,
};
const taskType = {
    // 人脸 人体 车辆 只看视频》》》》》》》》》》》》》》
    AUTOMOBILE_ATTRIBUTE,
    PEDESTRIAN_ATTRIBUTE,
    FACE_ATTRIBUTE,
    FACE_PEDESTRIAN_ALERT,
    FACE_ALERT,
    ROAD_DEFECTION_DETECT,
    // roi map body
    CROWD_STRAND,
    CROWD_DENSITY,
    // no map
    CROWD_RETROGRADE,
    // roi body
    CROWD_SOCIAL_DISTANCE,
    CROWD_INTRUSION,
    CROWD_CONGREGATE,
    // ROI
    TRASH_DETECT,
    KITCHEN_STAFF_DETECT,
    CROWD_CROSS_LINE_STATISTIC,
    ABNORMAL_BEHAVIOR_DETECT,
    FIRE_DETECTION_DETECT,
    TRAFFIC_RETROGRADE_DETECT,
    TRAFFIC_VIOLATION_DETECT,
    NONE_MOTOR_VEHICLE_PEDESTRIAN_DETECT,
    TRAFFIC_CONGESTION_DETECT,
    VIRTUAL_ZONE_STATISTIC,
    CROWD_STATISTIC,
    CROSS_LINE_ALERT_DETECT,
    PEDESTRIAN_CROSS_LINE,
    UNIDENTIFIED_OBJECT_RETENTION_DETECT,
    HUMAN_POWERED_VEHICLE_DETECT,
    EVERYTHING_DETECT, // 万物检测
};
const plotMap = new Map();
for (const item in taskType) {
    if (item) {
        plotMap.set(item, taskType[item]);
    }
}
export { plotMap, taskType, modelTypeData };
